/** Тип с ключами всех статусов
 * @typedef {"ready_for_connection"
 *   | "reserved_by_admin"
 *   | "awaiting_for_gu"
 *   | "not_connected"
 *   | "in_reservation"
 *   | "dirty_phone"} PhoneStatuses
 */

/** Коллекция возможных статусов
 * @type {Record<PhoneStatuses, string>}
 */
export const STATUS_LABELS = {
  ready_for_connection: "Готов к подключению",
  reserved_by_admin: "Забронирован",
  awaiting_for_gu: "Ожидает подачи заявления на ГУ",
  not_connected: "Не подключен",
  in_reservation: "В резервации",
  dirty_phone: "Шлейф",
};

/** Коллекция классов для блоков статусов
 * @type {Record<PhoneStatuses, string>}
 */
export const STATUS_CLASSES = {
  ready_for_connection: "status-badge-ready",
  reserved_by_admin: "status-badge-reserved",
  awaiting_for_gu: "status-badge-awaiting_for_gu",
  not_connected: "status-badge-not-connected",
  in_reservation: "status-badge-in-reservation",
  dirty_phone: "status-badge-dirty-phone",
};

/** Цвет статуса по умолчанию
 * @type {string}
 */
export const DEFAULT_STATUS_COLOR = "#6c757d";

/** Коллекция цветов для статусов
 * @type {Record<PhoneStatuses, string>}
 */
export const STATUS_COLORS = {
  ready_for_connection: "#28a745",
  reserved_by_admin: "#bb1dd4",
  awaiting_for_gu: "#e9b50c",
  not_connected: "#6c757d",
  in_reservation: "#6c757d",
  dirty_phone: "#765f75",
};

/** Статусы, которые не отображаем в таблице
 * @type {string[]}
 */
export const FORBIDDEN_STATUSES = ["not_connected", "in_reservation"];

/** Ключи общих ошибок, не относящихся к конкретному номеру
 * @type {string[]}
 */
export const COMMON_ERROR_KEYS = ["user", "project", "params", "service"];

/** Список доступных статусов для смены нескольких номеров
 * @type {{value: string; label: string;}[]}
 */
export const STATUS_OPTIONS = [
  { value: "ready_for_connection", label: "Готов к подключению" },
  { value: "reserved_by_admin", label: "Забронирован" },
  { value: "awaiting_for_gu", label: "Ожидает подачи заявления на ГУ" },
  { value: "dirty_phone", label: "Шлейф" },
];

/** Доступные значения лицензий
 * @type {number[]}
 */
export const LICENSE_OPTIONS = [30, 60, 120];
